
import { Component,Prop, BaseMixins } from '@/lib';
import CustomBreadCrumb from './custom-bread-crumb/index.vue'
import SiderTrigger from './sider-trigger/index.vue'
import './header-bar.less'

@Component({
  components:{CustomBreadCrumb,SiderTrigger}
})
export default class HeaderBar extends BaseMixins {
    @Prop({type:Boolean,default:false}) collapsed:boolean;

    get  breadCrumbList () {
      return this.$store.state.app.breadCrumbList
    }

     handleCollpasedChange (state) {
      this.$emit('on-coll-change', state)
    }
}

